/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Quick_Workout_Readiness_PctInputs */

const en_us2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% recovered`)
};

const pt_br2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% recuperado`)
};

const es_419_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% recuperado`)
};

const pt_pt2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% recuperado`)
};

const fr_fr2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct} % récupéré`)
};

const de_de2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% erholt`)
};

const it_it2_quick_workout_readiness_pct = /** @type {(inputs: Quick_Workout_Readiness_PctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% recuperato`)
};

/**
* | output |
* | --- |
* | "{pct}% recovered" |
*
* @param {Quick_Workout_Readiness_PctInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_readiness_pct = /** @type {((inputs: Quick_Workout_Readiness_PctInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Readiness_PctInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_readiness_pct(inputs)
	if (locale === "es-419") return es_419_quick_workout_readiness_pct(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_readiness_pct(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_readiness_pct(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_readiness_pct(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_readiness_pct(inputs)
	return en_us2_quick_workout_readiness_pct(inputs)
});
export { quick_workout_readiness_pct as "quick-workout.readiness_pct" }